export const extarctProfileName = profileName => {
  if (profileName) {
    const firstPart = profileName?.split('@');
    const takeNamePart = firstPart[0].split(',');
    const initialStr = takeNamePart.length === 2 ? `${takeNamePart[1]}.` : '';
    return `${initialStr}${takeNamePart[0]}`.replace(/\s/g, '').toLowerCase();
  }
  return '';
};
